<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Wellbeing Administration</b-navbar-brand>
			<b-collapse id="nav-collapse-sub" is-nav>
				<b-navbar-nav>
				<a href="#" @click="loadResilienceTab()">Resilience</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<b-modal id="modMessage" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="CMS Admin">
			<p class="my-4">{{message}}</p>
		</b-modal>
		<b-modal id="modSure" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Really?">
			<p class="my-4">Are you sure?</p>
			<p class="my-4">{{deleteWarningMessage}}</p>
			<template #modal-footer="{ ok, cancel }">
				<b-button variant="success" @click="delMethod()">Yes</b-button>
				<b-button variant="danger" @click="cancel()">No</b-button>
			</template>
		</b-modal> 
		<div class="row" v-if="tabIndex === 0">
			<div class="col-md-3 mb-4">
				<h2>Resilience Pillars</h2>
				<div class="row mb-1" v-for="p in pillars" :key="p.id">
					<b-button @click="pillar = p">{{p.name}}</b-button>
				</div>
				<div class="row mt-2 mb-1">
					<b-button v-if="!pillar" @click="newPillar()" variant="success"><b-icon-plus font-scale="1.5"/> New Pillar</b-button>
				</div>
				<div class="row mb-1" v-if="pillar">
					<b-button @click="savePillar()" variant="primary"><b-icon icon="check-circle-fill" font-scale="1.5"/> Save Current Pillar</b-button>
				</div>
				<div class="row mb-1" v-if="pillar">
					<b-button @click="deletePillarPressed()" variant="danger"><b-icon-trash font-scale="1.5"/> Delete Current Pillar</b-button>
				</div> 
				<p class="mt-5"><em>The more you like yourself, the less you are like anyone else, which makes you unique.</em></p>
			</div>
			<div class="col-md-9" v-if="pillar">
				<div class="m-5 mt-0">
					<h2>Pillar: {{pillar.name}}</h2>
					<div class="mb-2"><small>ID: {{pillar.id}}</small></div>
					Name: <b-form-input class="mb-2" v-model="pillar.name"></b-form-input> 
					description: <b-form-input class="mb-2" v-model="pillar.description"></b-form-input> 
					CMS article: <b-form-input class="mb-2" v-model="pillar.cmsPage"></b-form-input> 
					iconPath: <b-form-input class="mb-2" v-model="pillar.iconPath"></b-form-input>
					factName (admin only): <b-form-input class="mb-2" v-model="pillar.factName"></b-form-input>
					<b-row>
						<b-col> <h3>Components:</h3> </b-col>
						<b-col>
							<div class="row mt-2 mb-1">
								<b-button @click="newComponent()" variant="success"><b-icon-plus font-scale="1.5"/> New Component</b-button>
							</div>
						</b-col>
					</b-row>
					<p v-if="this.pillar.components.length == 0">While a pillar has no components, it will have a 'Coming Soon' label on the app. As soon as you attach components, users will be able to score themsleves for this pillar.</p>
					<div v-if="component" class="components-card m-5 mt-0">
						<h2>Add component</h2>
						Key (no spaces, CamelCase): <b-form-input class="mb-2" v-model="component.name"></b-form-input>
						Description: <b-form-input class="mb-2" v-model="component.description"></b-form-input>
						<b-row>
							<b-col>
								<div class="row m-2 mb-1">
									<b-button @click="saveComponent()" variant="success">Save</b-button>
								</div>
							</b-col>
							<b-col>
								<div class="row m-2 mb-1">
									<b-button @click="component = null">Cancel</b-button>
								</div>
							</b-col>
						</b-row>
					</div>
					<div v-for="c in pillar.components" :key="c.id" class="components-card m-5 mt-0">
						<p style="font-size:10px">ID: {{c.id}}</p>
						<b-row>
							<b-col>Key (no spaces, CamelCase):	</b-col>
							<b-col> 
								<b-form-input class="mb-2" v-model="c.name"></b-form-input>
							</b-col>
						</b-row>
						Description: <b-form-input class="mb-2" v-model="c.description"></b-form-input>
						<b-row>
							<b-col>
								<div class="row m-2 mb-1">
									<b-button @click="updatePillarComponent(c)" variant="success">Save</b-button>
								</div>
							</b-col>
							<b-col>
								<div class="row m-2 mb-1">
									<b-button @click="removeComponent()">Remove <b-icon icon="x-circle" font-scale="1.5"/></b-button>
								</div>
							</b-col>
						</b-row>
					</div>
				</div>
			</div>
		</div>
		<div class="row" v-if="tabIndex === 1"> Todo </div>
	</div>
</div>
</template>
<script>
export default {
  name: 'Wellbeing',
  data() {
	return{
		tabIndex: 0,
		pillars: null,
		pillar: null,
		component: null,
		createNewPillar: false,
		delMethod: null,
		message: null,
		deleteWarningMessage: null,
		error: null, 
	}
  },
  methods: {
	listPillars: function(autoSelect){
		this.$http.get(this.$config.ApiUri + "/FinancialResilience/Pillars")
			.then((result) => {
				this.pillars = result.data;
				if (autoSelect) {
					if (this.pillars.length > 0) {
						this.pillar = this.pillars[0];
					}
				}
			}
		)
	},
	newPillar() {
		this.pillar = { 
			"name": "",
			"description": "",
			"iconPath": "",
			"factName (admin only)": "",
			"cmsPage": "",
			"components": []
		};
	},
	savePillar: function(){
		if (this.isValidPillar()) {
			if (this.pillar.id == null || this.pillar.id == "") {
				this.$http.post(this.$config.ApiUri + "/FinancialResilience/Pillars", this.pillar)
					.then((result) => {
						this.pillar = result.data;
						this.listPillars(false);
						this.showMessage("Pillar created OK!");
					}
				).catch(() => { this.showError(); });
			}
			else {
				this.$http.put(this.$config.ApiUri + "/FinancialResilience/Pillars/" + this.pillar.id, this.pillar)
					.then((result) => {
						this.pillar = result.data;
						this.listPillars(false);
						this.showMessage("Pillar updated!");
					}
				).catch(() => { this.showError(); });
			} 
		}
	},
	isValidPillar: function() {
		if (this.pillar.name == "" || this.pillar.name == null 
			|| this.pillar.description == null || this.pillar.description == ""
		) {
			this.showMessage("pillar needs name and description.");
			return false;
		}
		if (this.pillar.cmsPage == "") {
			delete this.pillar.cmsPage;
		}
		return true;
	},
	isValidComponent: function() {
		if (this.component.name == "" || this.component.name == null 
			|| this.component.description == null || this.component.description == ""
		) {
			console.log(this.component);
			this.showMessage("component needs key and description.");
			return false;
		}
		return true;
	},
	deletePillarPressed() {
		this.deleteWarningMessage = "You will only be able to delete pillars that customers have not used. Talk to tech to delete pillars that have customer data.";
		this.delMethod = this.deletePillar;
		this.$bvModal.show('modSure');
	},
	deletePillar() {
		this.$bvModal.hide('modSure');
		this.$http.delete(this.$config.ApiUri + "/FinancialResilience/Pillars/" + this.pillar.id)
			.then(() => {
				this.pillar = null;
				this.listPillars(true);
				this.showMessage("Pillar deleted OK!");
			}
		).catch((error) => { this.showError("Sorry, that pillar cannot be deleted. (" + error + ")"); });
	},
	newComponent: function() {
		this.component = {
			"name": "",
			"description": ""
		}
	},
	updatePillarComponent: function(c) {
		this.component = c;
		if (this.isValidComponent()) {
			this.savePillar();
		}
		this.component = null;
	},
	saveComponent: function() {
		if (this.isValidComponent()) {
			this.pillar.components.push(this.component);
			this.component= null;
			this.savePillar();
		}
	},
	removeComponent: function(c) {
		var i = this.pillar.components.indexOf(c);
		this.pillar.components.splice(i, 1);
		this.savePillar();
	},
	loadResilienceTab() {
		this.tabIndex = 0;
		this.pillar = null;
		this.component = null;
		this.listPillars(true);
	},
	showMessage(message) {
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	showError(message) {
		if (!message) { message = "Sorry, that didn't work, please contact Tech"; }
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	onLoad() {
		this.listPillars(true);
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style>
.modal-header .close {
  display:none;
}
#criteria .btn-sm {
	margin:3px;
	font-size:10px;
}
.components-card {
	padding: 20px;
	margin-bottom: 20px;
	background-color:aliceblue;
}
.card2 {
	padding: 20px;
	margin: 20px;
	background-color:white;
}
.activeBtn {
  background: rgb(243, 16, 0) !important;
}
.answerButton {
	background: grey;
	font-size: 4px;
	margin: 2px;
}
</style>